// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".src-components-DomainNavigation-DomainNavigation__navigationButton--1NoDB{background-color:transparent;color:grey;height:36rem;border:none;width:15rem}.src-components-DomainNavigation-DomainNavigation__navigationButton--1NoDB:disabled{color:#fff!important}.src-components-DomainNavigation-DomainNavigation__closeButton--2qYdC{margin-left:36rem}", ""]);
// Exports
exports.locals = {
	"navigationButton": "src-components-DomainNavigation-DomainNavigation__navigationButton--1NoDB",
	"closeButton": "src-components-DomainNavigation-DomainNavigation__closeButton--2qYdC"
};
module.exports = exports;
